<template>
  <div class="form-group custom-form-group">
    <h3 class="checkbox-wrapper-label">
      {{ label }}
    </h3>
    <div class="checkbox-wrapper checkbox-wrapper-single">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SingleCheckbox',
  props: {
    label: { type: String }
  }
};
</script>
